var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import DateTimePicker from '../../../../components/DateTimePicker';
import Input from '../../../../components/Input';
import Select from '../../../../components/Select';
import MessageSearch, { initialFilter } from '../../hooks/MessageSearch';
import { SearchButton, SearchButtonWrapper, SearchFilterContainer, SearchFilterItem } from './styles/styles';
import t from '../../../../lib/translate';
import { addDays, subDays } from 'date-fns';
var DATE_RANGE_DAYS = 30; // Can search for messages in the last 30 days
var DATE_RANGE_LIMIT_DAYS = 4; // Maximum number of days between from date and to date
var SearchFilter = function () {
    var dateFormat = 'dd.MM.yyyy HH:mm';
    var _a = useState(initialFilter.fromDate), fromDate = _a[0], setFromDate = _a[1];
    var _b = useState(undefined), toDate = _b[0], setToDate = _b[1];
    var _c = useState(), recipient = _c[0], setRecipient = _c[1];
    var _d = useState(), status = _d[0], setStatus = _d[1];
    var _e = useState(), template = _e[0], setTemplate = _e[1];
    var _f = MessageSearch.useContainer(), setFilter = _f.setFilter, statusOptions = _f.statusOptions, templateOptions = _f.templateOptions;
    var translate = useState(localStorage.getItem('translateTemplateKeys') ? localStorage.getItem('translateTemplateKeys') === 'true' : true)[0];
    var minDate = subDays(new Date(), DATE_RANGE_DAYS);
    var maxDate = new Date();
    var maxRange = addDays(fromDate, DATE_RANGE_LIMIT_DAYS);
    var performSearch = function () {
        setFilter({
            fromDate: fromDate,
            toDate: toDate ? toDate : undefined,
            recipient: recipient ? recipient : undefined,
            status: status ? status.value : undefined,
            template: template ? template.value : undefined
        });
    };
    var translatedTemplateOptions = templateOptions.map(function (opt) { return ({
        label: translate ? t("templates.key.".concat(opt)) : opt,
        value: opt
    }); });
    var translatedStatusOptions = statusOptions.map(function (opt) { return ({
        label: t("statuses.".concat(opt)),
        value: opt
    }); });
    return (_jsxs(SearchFilterContainer, { children: [_jsx(SearchFilterItem, { children: _jsx(DateTimePicker, { label: t('messages.search.from.date'), format: dateFormat, value: fromDate, onChange: setFromDate, minDate: minDate, maxDate: maxDate }) }), _jsx(SearchFilterItem, { children: _jsx(DateTimePicker, { label: t('messages.search.to.date'), format: dateFormat, value: toDate, onChange: setToDate, minDate: fromDate, maxDate: maxRange }) }), _jsx(SearchFilterItem, { children: _jsx(Input, { sameHeightAsSelect: true, type: "text", label: t('messages.search.recipient'), fullWidth: true, placeholder: t('messages.search.recipient.placeholder'), onChange: function (e) { return setRecipient(e.target.value); } }) }), _jsx(SearchFilterItem, { children: _jsx(Select, { label: t('messages.table.headers.status'), options: translatedStatusOptions, onChange: function (e) { return setStatus(e); }, isClearable: true, escapeClearsValue: true }) }), templateOptions.length > 0 && _jsx(SearchFilterItem, { children: _jsx(Select, { label: t('messages.table.headers.template'), options: translatedTemplateOptions, onChange: function (e) { return setTemplate(e); }, isClearable: true, escapeClearsValue: true }) }), _jsx(SearchButtonWrapper, { children: _jsx(SearchButton, __assign({ onClick: performSearch }, { children: t('messages.search.label') })) })] }));
};
export default SearchFilter;
